/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { State } from './State';
import {
    StateFromJSON,
    StateFromJSONTyped,
    StateToJSON,
    StateToJSONTyped,
} from './State';

/**
 * 
 * @export
 * @interface FindAllStates200Response
 */
export interface FindAllStates200Response {
    /**
     * 
     */
    data?: Array<State>;
}

/**
 * Check if a given object implements the FindAllStates200Response interface.
 */
export function instanceOfFindAllStates200Response(value: object): value is FindAllStates200Response {
    return true;
}

export function FindAllStates200ResponseFromJSON(json: any): FindAllStates200Response {
    return FindAllStates200ResponseFromJSONTyped(json, false);
}

export function FindAllStates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllStates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StateFromJSON)),
    };
}

export function FindAllStates200ResponseToJSON(json: any): FindAllStates200Response {
    return FindAllStates200ResponseToJSONTyped(json, false);
}

export function FindAllStates200ResponseToJSONTyped(value?: FindAllStates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StateToJSON)),
    };
}

